/**
 * Badge Variant Mappers
 * Reusable functions for mapping status/role values to badge variants
 */

import type { BadgeVariant } from '@/components/ui/status-badge'

// ============================================================================
// Role Mappers
// ============================================================================

/**
 * Map member role to badge variant
 */
export function mapRoleToVariant(role: string): BadgeVariant {
  switch (role) {
    case 'owner':
      return 'purple'
    case 'admin':
      return 'info'
    case 'member':
      return 'neutral'
    case 'viewer':
      return 'neutral'
    default:
      return 'neutral'
  }
}

// ============================================================================
// Status Mappers
// ============================================================================

/**
 * Map member status to badge variant
 */
export function mapMemberStatusToVariant(status: string): BadgeVariant {
  switch (status) {
    case 'active':
      return 'success'
    case 'pending':
      return 'warning'
    case 'revoked':
      return 'error'
    default:
      return 'neutral'
  }
}

/**
 * Map API key status to badge variant
 */
export function mapApiKeyStatusToVariant(
  status: string | undefined
): BadgeVariant {
  switch (status) {
    case 'active':
      return 'success'
    case 'revoked':
      return 'error'
    case 'expired':
      return 'warning'
    default:
      return 'neutral'
  }
}

/**
 * Map project status to badge variant
 */
export function mapProjectStatusToVariant(status: string): BadgeVariant {
  switch (status) {
    case 'active':
      return 'success'
    case 'archived':
      return 'neutral'
    case 'suspended':
      return 'error'
    default:
      return 'neutral'
  }
}
